import Registration from '@/helpers/Registration';
import Requests from '@/helpers/Request';
import StorageHandler from '@/helpers/StorageHandler';
import router from '@/router';
import "core-js";

export default {
  namespaced: true,
  state: () => ({
    active: 'en',
    default: 'en',
    icon: '/static/img/language/icons/en.png',
  }),
  mutations: {
    setLanguage(state, value) {
      state.active = value;
    },
  },
  actions: {
    async init({ dispatch }) {
      // INIT LANGUAGE
      const value = StorageHandler.get('lang') || 'en';
      dispatch('set', value);
      return Promise.resolve();
    },
    // setLangDefault({ dispatch }, value) {
    //   // StorageHandler.save('lang', context.iso);
    //   dispatch('set', value);
    // },
    async set({ commit, dispatch }, value) {
      switch (value) {
        case 'en':
        case 'de':
        case 'ch_de':
        case 'ch_fr':
        case 'ch_it':
        case 'fr':
        case 'it':
        case 'es':
        case 'ru':
        case 'tr':
        case 'nl':
        case 'ar':
        case 'ko':
        case 'el':
        case 'pt':
        case 'hu':
        case 'da':
        case 'sv':
          commit('setLanguage', value);
          await StorageHandler.save('lang', value);
          break;
        default:
          dispatch(
            'notification/new',
            {
              title: 'Not supported Lang',
              message: value,
            },
            {
              root: true,
            }
          );
      }
      return Promise.resolve();
    },
    async select({ dispatch }, context) {
      await dispatch('set', context.iso);
      return Promise.resolve();
    },
  },
  getters: {
    getLang(state) {
      return state.active;
    },
    getLangItems(_, _get, _root, getters) {
      console.log(getters['navigation/getLangSubMenu']);
      if (!getters['navigation/getLangSubMenu']) return [];
      return getters['navigation/getLangSubMenu'].items;
    },
    getActiveLang(state, getters) {
      //if(window.lgVersion === '3.5') {
        return getters.getLangItems.find(function(el) {if(el.iso === state.active) return el;});
      //} else {
      //  return getters.getLangItems.find((el) => { el.iso === state.active });
      //}
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/lang.js